module.exports = __webpack_public_path__ + "img/shelfgram.c982a5b1.png";